import DOMPurify from "dompurify";
import { twMerge } from "tailwind-merge";
import type { TButton } from "./types";
import { buttonVariants } from "./variables";

export const Button = ({
  className,
  textClassName,
  variant,
  text,
  disabled = false,
  onClick,
}: TButton) => {
  const { wrapperClass, textClass, image } = buttonVariants[variant];

  const ButtonElement = document.createElement("button");
  ButtonElement.type = "button";
  ButtonElement.disabled = disabled;
  ButtonElement.className = twMerge(
    "flex items-center gap-2 cursor-pointer py-2 px-6 rounded-md disabled:cursor-not-allowed disabled:opacity-20",
    wrapperClass,
    className,
  );

  ButtonElement.innerHTML = DOMPurify.sanitize(/* html */ `
        <p class="${twMerge(
          "font-medium text-base ",
          textClass,
          textClassName,
        )}">
            ${text}
        </p>
    
        ${
          image
            ? /* html */ `<img src=${image.src} alt=${image.alt} class="w-3.5 h-3.5 object-contain" />`
            : ""
        }
    `);

  ButtonElement.addEventListener("click", onClick);

  return ButtonElement;
};
